<template>
  <div>
    <el-dialog
      title="分佣"
      :visible="dialogVisible"
      width="50%"
      @close="handleCloseAdd">
      <div class="content">
        <div>
          <el-table
            :data="tableData"
            style="width: 100%;overflow: auto">
            <el-table-column
              prop="fromName"
              label="购买人"
              >
            </el-table-column>
            <el-table-column
              prop="userName"
              label="用户名"
              width="100"
              >
            </el-table-column>
            <el-table-column
              prop="money"
              label="分佣金额"
              >
            </el-table-column>
            <el-table-column
              prop="status"
              label="分佣状态"
              >
              <template slot-scope="scope">
                {{['收入','支出','未结算','失效'][scope.row.status - 1]}}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="描述"
              width="200"
              >
            </el-table-column>
            <el-table-column
              v-if="type === 2"
              prop="goodsRevenueType"
              label="商品分佣级别"
              width="200"
              >
              <template slot-scope="scope">
                {{['一级','二级','团队长','区代理'][scope.row.goodsRevenueType - 1]}}
              </template>
            </el-table-column>
            <el-table-column
              v-if="type === 1"
              prop="serviceRevenueType"
              label="服务分佣级别"
              width="200"
              >
              <template slot-scope="scope">
                {{['区县代理分佣','市代理','省代理','团队长','商户'][scope.row.serviceRevenueType - 1]}}
              </template>
            </el-table-column>

            <el-table-column
              prop="okTime"
              label="到账时间"
              width="200"
              >
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="创建时间"
              width="200"
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCloseAdd">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      // 类型；1：服务订单；2：商品订单
      type: '',
    };
  },
  mounted() {
  },
  components: {
  },
  methods: {
    /**
     * 打开弹窗
     */
    openDia(e, item) {
      this.type = e
      this.dialogVisible = true
      // 获取分佣列表
      this.getList(e, item.id)
    },
    /**
     * 获取分佣列表
     */
    getList(e, item) {
      let params = {
        orderId: item,
        // 1：服务订单，2：会员礼包；3：服务套餐；4：商户小程序商品订单；5：平台合伙人奖金池；6：平台合伙人推荐奖 7：聚合平台商品订单
        typeIds: e
      }
      this.$api.merchant.businessRevenue(params).then(res =>{
        this.tableData = res.data.data
      })
    },
    /**
     * 关闭弹窗
     */
    handleCloseAdd(formName) {
      this.dialogVisible = false
    },
  }
};
</script>

<style  scoped>
.first-title{
  display: flex;
  align-items: center;
}
.first-title-icon{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-bottom: 10px;
  margin-right: 10px;
  background: #FF5722;
}
.first-title-word{
  flex: 1;
  box-sizing: border-box;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationServiceSub.vue